// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2EEKN","actions":"GroupTable_actions__2Lh7M","deleteModalFooter":"GroupTable_deleteModalFooter__1WcZY"};